"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 被監査部門（複数行対応用）
 */
class MultiLineText extends _react.default.Component {
  render() {
    const renderTexts = () => {
      if (typeof this.props.children === 'string') {
        return this.props.children.split(',').map((m, i) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
          key: i
        }, /*#__PURE__*/_react.default.createElement("span", null, m), /*#__PURE__*/_react.default.createElement("br", null)));
      } else {
        return '';
      }
    };
    return /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, renderTexts());
  }
}
exports.default = MultiLineText;